/**
 * Display helpers for article story categories (SDM-23 / Sprint 33 ops verification).
 * Prefer LLM {@code categories[]}; fall back to legacy single {@code category}.
 * Does not apply feed {@code categoryOverride} — that is search-filter only.
 */

/** Canonical lowercase labels for routing / equality. */
export function articleCategoryLabels(article) {
  if (!article) {
    return [];
  }
  const out = [];
  if (Array.isArray(article.categories)) {
    for (const c of article.categories) {
      if (c == null) continue;
      const label = String(c).trim().toLowerCase();
      if (label && !out.includes(label)) {
        out.push(label);
      }
    }
  }
  if (out.length === 0 && article.category) {
    const legacy = String(article.category).trim().toLowerCase();
    if (legacy) {
      out.push(legacy);
    }
  }
  return out;
}

/** Title-case a canonical lowercase category for UI display. */
export function displayCategoryLabel(label) {
  if (!label) return '';
  return String(label)
    .trim()
    .toLowerCase()
    .replace(/\b\w/g, (ch) => ch.toUpperCase());
}

export function formatArticleCategories(article, sep = ' · ') {
  return articleCategoryLabels(article).map(displayCategoryLabel).join(sep);
}
